import React, { FunctionComponent } from 'react';

import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';

import Alert from '@mui/material/Alert';

import Button from '@mui/material/Button';

import { styled } from '@mui/material/styles';

type Props = {
    title: string,
    message: string,
    showErrorDialog: boolean,
    setShowErrorDialog: (v: boolean) => void
};

// const StyledDialog = styled(Dialog)(({ theme }) => ({
//   '& .MuiPaper-root': {
//     backgroundColor: theme.palette.error.main,
//     color: theme.palette.error.contrastText,
//   },
// }));

const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
  backgroundColor: theme.palette.error.light,
  color: theme.palette.error.contrastText,
}));

const ErrorDialog: FunctionComponent<Props> = ({title, message, showErrorDialog, setShowErrorDialog}) => {

    const close = () => {
        setShowErrorDialog(false);
    }

    return (
        <Dialog open={showErrorDialog} onClose={close}>
          <StyledDialogTitle>{title}</StyledDialogTitle>
          <DialogContent>
            {/* <p>{message}</p> */}
            <Alert severity="error" sx={{ backgroundColor: 'inherit', color: 'inherit' }}>
              {message}
            </Alert>
          </DialogContent>
          <DialogActions>
              <Button variant="contained" onClick={close}>Fermer</Button>
          </DialogActions>
        </Dialog>
    )

}

export default ErrorDialog;